import {
  ChainActionTypes,
  fetchChainFailure,
  fetchChainSuccess,
} from "actions";
import { SagaIterator } from "redux-saga";
import { call, delay, put, takeLatest } from "redux-saga/effects";
import { ApiBaseUrl } from "utils";

export interface IChain {
  block_height: number;
  current_epoch: number;
  absolute_slot: number;
  transaction_count: number;
}

const fetchChainApi = async () => {
  const response = await fetch(ApiBaseUrl + `/api/chaininfo`);

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return await response.json();
};

// Worker Saga
function* fetchChainData(): SagaIterator {
  try {
    const data: IChain = yield call(fetchChainApi);
    yield put(fetchChainSuccess(data));
  } catch (error: any) {
    yield put(fetchChainFailure(error.message || "Unknown error occurred"));
  }
}

function* autoReloadChainData() {
  while (true) {
    yield call(fetchChainData); // call fetchChainData
    yield delay(1000); // Wait for 1 second
  }
}

// Watcher Saga
export function* watchChainSaga() {
  yield takeLatest(ChainActionTypes.FETCH_CHAIN_REQUEST, autoReloadChainData);
}
